class GetBiodataByIdUseCase {
    /**
     * @param {BiodataRepository} biodataRepository
     */
    constructor(biodataRepository) {
        this.biodataRepository = biodataRepository;
    }

    /**
     * @param {string} biodataId
     * @returns {Promise<Biodata>}
     */
    async execute(biodataId) {
        return this.biodataRepository.getBiodataById(biodataId);
    }
}

export default GetBiodataByIdUseCase;
